/**
 * Gates merch pills behind the `xdp-hero-badges` Statsig layer (CVR-2719).
 */
import { useLayer } from '@coursera-web/statsig';

export default function useShouldShowMerchPills() {
  const layer = useLayer('xdp-hero-badges');
  const shouldShowMerchPills = layer.get('show-merch-pills', false);

  return shouldShowMerchPills;
}
